import getCdnUrl from '../../../helpers/get-cdn-url';

const BancoDeChileLogo = getCdnUrl('/logos/banco-de-chile.webp');

export default BancoDeChileLogo;
